import { Flex, Button } from "@chakra-ui/react";
import { DisruptedCTAProps } from "../DisruptedCTA";

const OriginalCTA0 = ({
  t,
  onAnotherClaimReasonClick,
  onSubmit,
  isSubmitting,
  isCancelled,
}: DisruptedCTAProps) => {
  return (
    <Flex direction={{ base: "column-reverse", md: "row" }} gap="4">
      <Button
        size="l"
        variant="secondary"
        onClick={onAnotherClaimReasonClick}
        disabled={isSubmitting}
        data-testid="claim-flight-for-another-reason-button"
      >
        {t("steps.disrupted_flight_detected.claim_for_other_reason")}
      </Button>
      <Button
        size="l"
        onClick={onSubmit}
        isLoading={isSubmitting}
        data-testid="claim-flight-button"
      >
        <span>
          {!isCancelled
            ? t("steps.disrupted_flight_detected.delayed.continue")
            : t("steps.disrupted_flight_detected.cancelled.continue")}
        </span>
      </Button>
    </Flex>
  );
};

export default OriginalCTA0;
